var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ui-buttonv2--pill",class:( _obj = {
    'ui-buttonv2--block': _vm.block
  }, _obj[("ui-buttonv2--" + _vm.size)] = true, _obj[("ui-buttonv2--" + _vm.variant)] = true, _obj ),attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }